module.exports = __webpack_public_path__ + "static/dk-promotion-pump-solarcell-d252941d121b25a33b96c1ed4d8229d3.webp";